module.exports = __webpack_public_path__ + "static/img/rules-content.d0a106d3.png";